import { useEffect, useRef, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

// Routes
import DepositRoutes from "./Routes";

// Redux
import { setDepositData, setDataBankCustomerAll } from "./../../../../../@core/redux/actions/deposit/index";
import { setStatusSpinner } from "./../../../../../@core/redux/actions/app/spinner";

// auth
import { isUserLoggedIn } from "./../../../../../@core/auth/utils";

// Services
import { loadBankDepositAll } from "./../../../../../@core/services/bankService";
import { loadDepositFirst } from "./../../../../../@core/services/depositService";

// @utility
import { setStorage } from "./../../../../../@utility/app/storage";
import alertText from "./../../../../../@utility/app/alertText";

// Components
import CloseButton from "./../../components/CloseButton";
import SnackbarSet from "./../../components/SnackbarSet";
import DepositPopupImage from "./component/PopupImage";

//  CSS
import modalStyles from "./../../assets/css/Modal.module.css";

const Layouts = ({ menu_status = 1 }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const childRef = useRef();

    // Redux State
    const depositItems = useSelector(state => state.reduxDeposit.result);
    const reduxAppCMS = useSelector(state => state.reduxAppCMS.cms);
    const dataBankCustomerList = useSelector(state => state.reduxDeposit.dataBank);

    // Local State
    const [loadBank, setLoadBank] = useState(false);
    const [iosPreviewUrl, setIosPreviewUrl] = useState(null);

    // ประเมินค่า Auth เพียงครั้งเดียวต่อรอบการ Render แทนการเรียกฟังก์ชันซ้ำๆ ใน JSX
    const isLoggedIn = isUserLoggedIn();

    // นำ Side effect ออกจาก Render body มาไว้ใน useEffect
    useEffect(() => {
        document.title = process.env.REACT_APP_OG_SITE_NAME + " - เติมเงิน";
    }, []);

    // ใช้ useCallback เพื่อป้องกันไม่ให้ฟังก์ชันถูกสร้างใหม่ทุกครั้งที่ Render 
    // ซึ่งจะช่วยป้องกันไม่ให้ <DepositRoutes /> Re-render โดยไม่จำเป็น
    const loadBankDeposit = useCallback(() => {
        loadBankDepositAll().then((data) => {
            const statusCode = data.code;
            if (statusCode === 200 || statusCode === 0) {
                dispatch(setDataBankCustomerAll(data.result));
            }
            // เรียกใช้แค่ครั้งเดียว ไม่ว่าจะเข้าเงื่อนไขไหน
            setLoadBank(true);
        });
    }, [dispatch]);

    useEffect(() => {
        // ตรวจสอบสถานะเมนู
        if (menu_status !== 1 && menu_status !== undefined) {
            history.push("/");
            return; // หยุดการทำงานถ้าถูก Redirect
        }

        // โหลดข้อมูล Bank เมื่อไม่มีข้อมูล
        if (!dataBankCustomerList) {
            loadBankDeposit();
        }
    }, [menu_status, history, dataBankCustomerList, loadBankDeposit]);

    useEffect(() => {
        // นำ reloadData มาไว้ใน useEffect เพื่อป้องกันปัญหา Stale Closure และไม่ต้องสร้างฟังก์ชันซ้ำซ้อน
        const reloadData = () => {
            if (isLoggedIn) {
                let snackbarJson = {};
                
                if (depositItems === false) {
                    dispatch(setStatusSpinner({ status: true, textProcess: null }));
                }

                loadDepositFirst().then((data) => {
                    const statusCode = data.code;
                    dispatch(setStatusSpinner({ status: false, textProcess: null }));

                    if (statusCode === 200 || statusCode === 0) {
                        const result = data?.result;
                        if (!result) return;

                        // บันทึก Storage เท่าที่จำเป็น
                        if (result.pay_src) setStorage("paySrc", result.pay_src);
                        if (result.pay_mode) setStorage("payMode", result.pay_mode);
                        if (result.pay_time_out) setStorage("payTimeOut", result.pay_time_out);

                        const payAccountData = result.pay_account;
                        const payResultData = result.payment_result?.account;

                        if (payAccountData?.code) {
                            setStorage("payAccount", JSON.stringify(payAccountData));
                        } else if (payResultData) {
                            setStorage("payAccount", JSON.stringify({ 
                                account: payResultData.account_no, 
                                code: payResultData.bank_code, 
                                name: payResultData.account_name 
                            }));
                        } else {
                            setStorage("payAccount", JSON.stringify(payAccountData));
                        }

                        if (result.pay_mode === "crypto") {
                            setStorage("paySrc", payAccountData?.account);
                        }

                        if (result.payment_result?.crypto_fx_rate) {
                            setStorage("payRate", result.payment_result.crypto_fx_rate);
                        }

                        if (result.pay_amount) {
                            const finalAmount = result.payment_result?.crypto_amount || result.pay_amount;
                            setStorage("payAmount", finalAmount);
                        }

                        const firstEventTimestamp = result.qrcode_time_out 
                            ? Date.now(result.qrcode_time_out) 
                            : Date.now();
                        const timeStart = result.qrcode_time_out 
                            ? firstEventTimestamp 
                            : firstEventTimestamp + (5 * 60 * 1000);
                            
                        setStorage("depositPromptPayTime", timeStart);

                        if (result.payment_result) {
                            setStorage("paymentResult", JSON.stringify(result.payment_result));
                        }

                        dispatch(setDepositData(result));
                        
                        if (result.mode === "pay") {
                            setStorage("processDeposit", result.id);
                        }
                    } else {
                        dispatch(setDepositData(null));
                        snackbarJson = alertText(statusCode);
                        childRef.current?.snackbar(snackbarJson);

                        if (statusCode === 2 || statusCode === 4) {
                            setTimeout(() => {
                                window.location.href = `/`;
                            }, 5000);
                        }
                    }
                });
            } else {
                dispatch(setStatusSpinner({ status: false, textProcess: null }));
            }
        };

        reloadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, isLoggedIn]); 
    // ^ ใช้ตัวแปร isLoggedIn แบบ Boolean แทนการเรียกฟังก์ชันใน Dependency array

    return (
        <>
            <div className={modalStyles.contentPosition}>
                <div className={modalStyles.boxBodyFull}>
                    <div className={modalStyles.boxFull}>
                        <div className={modalStyles.closeButtonFull}>
                            <CloseButton backPage="/"></CloseButton>
                        </div>
                        <div className={modalStyles.boxContentWidthFull}>
                            {
                                (depositItems !== false || !isLoggedIn) && (
                                    <DepositRoutes
                                        isUserLoggedIn={isLoggedIn}
                                        depositItems={depositItems}
                                        reduxAppCMS={reduxAppCMS}
                                        loadBankDeposit={loadBankDeposit}
                                        loadBank={loadBank}
                                        iosPreviewUrl={iosPreviewUrl}
                                        setIosPreviewUrl={setIosPreviewUrl}
                                    />
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className={modalStyles.fixedBackdrop}></div>
            <SnackbarSet ref={childRef} />

            {
                (depositItems?.mode === "pay" && iosPreviewUrl) && (
                    <DepositPopupImage iosPreviewUrl={iosPreviewUrl} setIosPreviewUrl={setIosPreviewUrl} />
                )
            }
        </>
    );
}

export default Layouts;